import { render, staticRenderFns } from "./checkboxRightsDesignDialog.vue?vue&type=template&id=6384d4c1&scoped=true"
import script from "./checkboxRightsDesignDialog.vue?vue&type=script&lang=js"
export * from "./checkboxRightsDesignDialog.vue?vue&type=script&lang=js"
import style0 from "./checkboxRightsDesignDialog.vue?vue&type=style&index=0&id=6384d4c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6384d4c1",
  null
  
)

export default component.exports